import React from "react";

const PlusIcon = ({ size = 24, color = "#000", strokeWidth = 1.5 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 64.000000 64.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)"
        fill={color}
        stroke="none"
      >
        <path
          d="M140 558 c-19 -13 -45 -39 -58 -58 -22 -33 -23 -41 -20 -187 3 -135
5 -155 24 -179 47 -64 63 -69 219 -72 164 -4 196 5 243 66 27 35 27 37 27 193
0 144 -2 160 -21 185 -47 64 -62 69 -227 72 -146 3 -154 2 -187 -20z m198
-171 l3 -46 47 -3 c34 -2 47 -7 47 -18 0 -11 -13 -16 -47 -18 l-47 -3 -3 -47
c-2 -34 -7 -47 -18 -47 -11 0 -16 13 -18 47 l-3 47 -47 3 c-34 2 -47 7 -47 18
0 11 13 16 48 18 l47 3 0 43 c0 23 3 46 7 50 16 15 28 -3 31 -47z"
        />
      </g>
    </svg>
  );
};

export default PlusIcon;
